import Linkify from 'linkify-react';
import { Box, Card, CardMedia } from '@mui/material';
import { useTimelineDetailsBubbleStyles } from './timeline-details-bubble.styles';
import { Alert } from '@mui/material';
import { decodeImageURL } from '../../../../util/image-url';

export function TimelineDetailsBubble({
  content,
  title,
  imageURL,
  disclaimer
}: {
  title: string;
  content: string;
  imageURL?: string;
  disclaimer?: string;
}) {
  const classes = useTimelineDetailsBubbleStyles();

  return (
    <Card className={classes.card}>
      <p className={classes.title}>{title}</p>

      <p className={classes.content}>
        <Linkify
          options={{
            className: classes.link,
            target: '_blank'
          }}
        >
          {content}
        </Linkify>
      </p>
      {disclaimer ? (
        <Box className={classes.disclaimerOuter}>
          <Alert severity="info" classes={{ root: classes.alert }}>
            {disclaimer}
          </Alert>
        </Box>
      ) : (
        ''
      )}
      {imageURL ? (
        <div className={classes.imageOuter}>
          <CardMedia className={classes.imageURL} component="img" image={decodeImageURL(imageURL)} alt="Image taken" />
        </div>
      ) : (
        ''
      )}
    </Card>
  );
}
